import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Voicemail"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.9998 7.49988C16.2269 7.50346 14.6213 8.54772 13.8991 10.1669C13.177 11.7861 13.4728 13.6784 14.6548 14.9999H9.3448C10.7609 13.4166 10.877 11.0587 9.62333 9.34398C8.36965 7.62923 6.08762 7.02468 4.14941 7.89384C2.21119 8.76299 1.14472 10.8691 1.59123 12.9458C2.03774 15.0225 3.87563 16.5042 5.9998 16.4999H17.9998C20.4851 16.4999 22.4998 14.4852 22.4998 11.9999C22.4998 9.5146 20.4851 7.49988 17.9998 7.49988ZM2.99981 11.9999C2.99981 10.343 4.34295 8.99988 5.99981 8.99988C7.65666 8.99988 8.99981 10.343 8.99981 11.9999C8.99981 13.6567 7.65666 14.9999 5.99981 14.9999C4.34295 14.9999 2.99981 13.6567 2.99981 11.9999ZM17.9998 14.9999C16.343 14.9999 14.9998 13.6567 14.9998 11.9999C14.9998 10.343 16.343 8.99988 17.9998 8.99988C19.6567 8.99988 20.9998 10.343 20.9998 11.9999C20.9998 12.7955 20.6837 13.5586 20.1211 14.1212C19.5585 14.6838 18.7955 14.9999 17.9998 14.9999Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Voicemail.vue"]]);
